import FilterList from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';

const filtersRoleTable: FilterList[] = [
	{
		label: 'Name',
		key: 'name',
		value: '',
		placeHolder: 'Enter a name',
		type: 'text',
	},
	{
		label: 'Client',
		key: 'client',
		value: '',
		placeHolder: 'Enter a client',
		type: 'text',
	},
];

export default filtersRoleTable;
